import React from "react";

type StatusMeta = {
  label: string;
  color: string;
  /** If set, shown as native tooltip on hover (e.g. enquiry / quotation status maps). */
  hint?: string;
};

type StatusBadgeProps = {
  value: string | number | undefined;
  map: Record<string, StatusMeta>;
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ value, map }) => {
  if (!value) return null;

  const meta = map[String(value)] ?? {
    label: String(value),
    color: "secondary",
  };

  return (
    <span
      className={`badge bg-${meta.color}-subtle text-${meta.color} text-capitalize`}
      title={meta.hint?.trim() || undefined}
      style={meta.hint?.trim() ? { cursor: "help" } : undefined}
    >
      {meta.label}
    </span>
  );
};

export default StatusBadge;
